<template>
  <v-chip
    v-if="errore"
    small
    color="red lighten-4"
    @click="riprova"
  >
    <v-icon left small color="red">mdi-alert</v-icon>
    Salvataggio fallito — riprova
  </v-chip>
  <v-chip v-else-if="in_corso" small color="blue lighten-5">
    <v-progress-circular indeterminate size="12" width="2" class="mr-2" />
    Salvataggio…
  </v-chip>
  <v-chip v-else-if="pendenti" small color="grey lighten-3">
    {{ pendenti }} da salvare
  </v-chip>
  <v-chip v-else small color="green lighten-5">
    <v-icon left small color="green">mdi-check</v-icon>
    Salvato
  </v-chip>
</template>

<script>
/**
 * Stato del buffer di scrittura delle quantità.
 *
 * È l'unico segnale che le modifiche non sono ancora sul server: con le
 * scritture in batch non c'è più uno spinner per cella.
 */
export default {
  computed: {
    pendenti() {
      return this.$store.getters["crisantemi/modifiche_pendenti"];
    },
    in_corso() {
      return this.$store.getters["crisantemi/salvataggio_in_corso"];
    },
    errore() {
      return this.$store.getters["crisantemi/errore_salvataggio"];
    },
  },
  methods: {
    riprova() {
      this.$store.dispatch("crisantemi/flush").catch(() => {});
    },
  },
};
</script>
